import * as tslib_1 from "tslib";
import * as React from 'react';
import { DragSource } from 'react-dnd';
import { observer, inject } from 'mobx-react';
import { Card, CardHeader, CardActions } from 'material-ui/Card';
import { TaskDetail } from './TaskDetail';
import { TaskStatusMenu } from './TaskStatusMenu';
import { avatar, monogram } from 'src/models/User';
import TaskProgress from './TaskProgress';
import TaskCardBadges from './TaskCardBadges';
import { Avatar, FontIcon, IconButton } from 'material-ui';
import { getTaskCardPrimaryTitle, getTaskCardSubtitle } from '../../models/CardDisplayVersions';
var styles = {
    header: {
        textOverflow: 'ellipsis',
    },
    title: {
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        textOverflow: 'ellipsis',
    },
    item: {
        margin: '1rem 0',
        padding: '0',
        color: '#414141'
    },
    text: {
        fontSize: '12px',
        paddingRight: 0,
        maxWidth: '300px',
    }
};
var dragSource = {
    canDrag: function (props) {
        return !props.isDragging && props.task.canDrag();
    },
    beginDrag: function (props) {
        return {
            task: props.task
        };
    }
};
var TaskCard = /** @class */ (function (_super) {
    tslib_1.__extends(TaskCard, _super);
    function TaskCard(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDetailOpen = function (e) {
            e.preventDefault();
            _this.setState({ isDetailOpen: true });
        };
        _this.handleDetailClose = function () {
            _this.setState({ isDetailOpen: false });
        };
        _this.state = {
            isDetailOpen: false
        };
        return _this;
    }
    TaskCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, color = _a.color, task = _a.task, connectDragSource = _a.connectDragSource, preferencesStore = _a.preferencesStore;
        var avatarElement = this.props.preferencesStore.cardAvatarVisible.value
            ? avatar(task.userId)
            : React.createElement("span", { title: task.userName },
                React.createElement(Avatar, null, monogram(task.userName)));
        var subtitle = !this.props.preferencesStore.cardDetailVisible.value
            ? React.createElement("span", null, task.stepName)
            : getTaskCardSubtitle(preferencesStore.cardDisplayVersion.value, task);
        var deleteIcon = !task.own ? null : (React.createElement("div", { style: { height: '30px' } },
            React.createElement(IconButton, { onClick: function () { return _this.props.taskStore.deleteTask(task); }, style: { transform: 'translateY(-15px)' } },
                React.createElement(FontIcon, { className: "material-icons", color: "#777" }, "delete"))));
        return connectDragSource(React.createElement("div", null,
            React.createElement(Card, { style: styles.item },
                React.createElement(CardHeader, { className: this.props.preferencesStore.cardProgressVisible.value ? 'card-header' : 'card-header-mini', textStyle: styles.text, avatar: avatarElement, style: styles.header, titleStyle: styles.title, title: (React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-start' }, onClick: this.handleDetailOpen },
                        React.createElement("div", null, getTaskCardPrimaryTitle(preferencesStore.cardDisplayVersion.value, task)),
                        deleteIcon)), subtitle: subtitle },
                    React.createElement(TaskCardBadges, { task: task })),
                React.createElement(CardActions, { style: { padding: 0 } },
                    React.createElement(TaskProgress, { task: task, color: color }),
                    this.renderStatusMenu(preferencesStore, task))),
            React.createElement(TaskDetail, { task: task, isOpen: this.state.isDetailOpen, onClose: this.handleDetailClose })));
    };
    TaskCard.prototype.renderStatusMenu = function (preferencesStore, task) {
        if (!preferencesStore.hasSmallScreen || task.isReadonly) {
            return null;
        }
        return React.createElement(TaskStatusMenu, { task: task });
    };
    TaskCard = tslib_1.__decorate([
        DragSource('scrumBoardItem', dragSource, function (connect, monitor) { return ({
            connectDragSource: connect.dragSource(),
            connectDragPreview: connect.dragPreview(),
            isDragging: monitor.isDragging(),
        }); }),
        inject('preferencesStore', 'taskStore'),
        observer
    ], TaskCard);
    return TaskCard;
}(React.Component));
export { TaskCard };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskCard.tsx
// module id = 732
// module chunks = 0